const keyShortcutBlockedClassName = "key-shortcut-blocked";

export default keyShortcutBlockedClassName;
